
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hospitals/[hospitalPid]",
      function () {
        return require("private-next-pages/hospitals/[hospitalPid]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hospitals/[hospitalPid]"])
      });
    }
  